import React from 'react';

export default function About() {
  return (
    <section className="relative min-h-[85vh] flex items-center justify-center overflow-hidden py-20">
      <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
        {/* Header */}
        <div className="text-center mb-12 sm:mb-16">
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-extrabold text-white mb-4 sm:mb-6 tracking-tight">
            About Syltix
          </h1>
          <p className="text-base sm:text-lg md:text-xl text-white/80 max-w-3xl mx-auto leading-relaxed px-2">
            We design and develop robust digital platforms for businesses that require more than standard websites.
          </p>
        </div>

        {/* Mission & Vision */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6 mb-8 sm:mb-12">
          <div 
            className="rounded-2xl p-6 sm:p-8"
            style={{
              background: 'rgba(255, 255, 255, 0.12)',
              backdropFilter: 'blur(16px)',
              WebkitBackdropFilter: 'blur(16px)',
              border: '1px solid rgba(255, 255, 255, 0.25)',
              boxShadow: '0 8px 32px 0 rgba(0, 0, 0, 0.1)',
            }}
          >
            <h2 className="text-2xl sm:text-3xl font-extrabold text-white mb-4">Our Mission</h2>
            <p className="text-white/80 text-base sm:text-lg leading-relaxed">
              To accelerate humanity's progress by delivering transformative technology solutions that solve tomorrow's challenges today.
            </p>
          </div>
          <div 
            className="rounded-2xl p-6 sm:p-8"
            style={{
              background: 'rgba(255, 255, 255, 0.12)',
              backdropFilter: 'blur(16px)',
              WebkitBackdropFilter: 'blur(16px)',
              border: '1px solid rgba(255, 255, 255, 0.25)',
              boxShadow: '0 8px 32px 0 rgba(0, 0, 0, 0.1)',
            }}
          >
            <h2 className="text-2xl sm:text-3xl font-extrabold text-white mb-4">Our Vision</h2>
            <p className="text-white/80 text-base sm:text-lg leading-relaxed">
              A world where technology amplifies human potential, connects minds, and unlocks new frontiers for all.
            </p>
          </div>
        </div>

        {/* Team Section */}
        <div className="mb-8 sm:mb-12">
          <h2 className="text-xl sm:text-2xl md:text-3xl font-extrabold text-white mb-4 sm:mb-6 text-center">Meet the Team</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6 max-w-2xl mx-auto">
            <div 
              className="rounded-2xl p-6 text-center"
              style={{
                background: 'rgba(255, 255, 255, 0.12)',
                backdropFilter: 'blur(16px)',
                WebkitBackdropFilter: 'blur(16px)',
                border: '1px solid rgba(255, 255, 255, 0.25)',
                boxShadow: '0 8px 32px 0 rgba(0, 0, 0, 0.1)',
              }}
            >
              <div className="font-bold text-xl text-white mb-2">Alex Quantum</div>
              <div className="text-white/70 text-sm sm:text-base">Founder & CEO</div>
            </div>
            <div 
              className="rounded-2xl p-6 text-center"
              style={{
                background: 'rgba(255, 255, 255, 0.12)',
                backdropFilter: 'blur(16px)',
                WebkitBackdropFilter: 'blur(16px)',
                border: '1px solid rgba(255, 255, 255, 0.25)',
                boxShadow: '0 8px 32px 0 rgba(0, 0, 0, 0.1)',
              }}
            >
              <div className="font-bold text-xl text-white mb-2">Jamie Neural</div>
              <div className="text-white/70 text-sm sm:text-base">CTO, AI & Neurotech</div>
            </div>
          </div>
        </div>

        {/* Journey Section */}
        <div>
          <h2 className="text-xl sm:text-2xl md:text-3xl font-extrabold text-white mb-6 sm:mb-8 text-center">Our Journey</h2>
          <div 
            className="rounded-2xl p-5 sm:p-6 md:p-8 max-w-3xl mx-auto"
            style={{
              background: 'rgba(255, 255, 255, 0.12)',
              backdropFilter: 'blur(16px)',
              WebkitBackdropFilter: 'blur(16px)',
              border: '1px solid rgba(255, 255, 255, 0.25)',
              boxShadow: '0 8px 32px 0 rgba(0, 0, 0, 0.1)',
            }}
          >
            <ol className="relative border-l-2 border-white/30 ml-4 sm:ml-6">
              <li className="mb-8 ml-6 sm:ml-8">
                <span className="absolute -left-3 sm:-left-4 flex items-center justify-center w-6 h-6 sm:w-8 sm:h-8 bg-white/20 rounded-full ring-4 ring-transparent" 
                  style={{ border: '2px solid rgba(255, 255, 255, 0.5)' }}
                />
                <h3 className="font-bold text-xl sm:text-2xl text-white mb-2">2022: Syltix Founded</h3>
                <p className="text-white/70 text-sm sm:text-base">A vision for a cyberpunk future is born.</p>
              </li>
              <li className="mb-8 ml-6 sm:ml-8">
                <span className="absolute -left-3 sm:-left-4 flex items-center justify-center w-6 h-6 sm:w-8 sm:h-8 bg-white/20 rounded-full ring-4 ring-transparent" 
                  style={{ border: '2px solid rgba(255, 255, 255, 0.5)' }}
                />
                <h3 className="font-bold text-xl sm:text-2xl text-white mb-2">2023: First AI Product Launch</h3>
                <p className="text-white/70 text-sm sm:text-base">Revolutionizing business automation with neural AI.</p>
              </li>
              <li className="ml-6 sm:ml-8">
                <span className="absolute -left-3 sm:-left-4 flex items-center justify-center w-6 h-6 sm:w-8 sm:h-8 bg-white/20 rounded-full ring-4 ring-transparent" 
                  style={{ border: '2px solid rgba(255, 255, 255, 0.5)' }}
                />
                <h3 className="font-bold text-xl sm:text-2xl text-white mb-2">2024: Quantum Platform Debuts</h3>
                <p className="text-white/70 text-sm sm:text-base">Pushing the boundaries of computation and connectivity.</p>
              </li>
            </ol>
          </div>
        </div>
      </div>
    </section>
  );
} 